import React from "react";
import styles from "../Dashoard.module.css";
import CourseImg from "../../../assets/imgs/Session-img.png";
import { Box, Container, Grid } from "@mui/material";

const ReminderSection = (props) => {
  const { sessionsUpcoming, studentNumber } = props;

  return (
    <>
      <div className={styles.CardSection}>
        <div className={styles.CardSectionInner}>
          <div className={styles.ReminderCard}>
            <p className={styles.ReminderCardTitle}>Upcoming Sessions</p>
            <h1>{sessionsUpcoming?.length}</h1>
          </div>

          <div className={styles.ReminderCard}>
            <p className={styles.ReminderCardTitle}>Total users</p>
            <h1>{studentNumber}</h1>
          </div>

          {/* <div className={styles.ReminderCard}>
            <p className={styles.ReminderCardTitle}>TBD</p>
            <h1>0</h1>
          </div>

          <div className={styles.ReminderCard}>
            <p className={styles.ReminderCardTitle}>TBD</p>
            <h1>0</h1>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ReminderSection;
